// client/src/components/logistics/AddDriverModal.js
import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import './AddDriverModal.css'; // Nayi unique CSS file

const AddDriverModal = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    username: '',
    mobileNo: '',
    uniqueId: '',
    address: '',
    licenseNo: '',
    licenseValidity: '',
    salary: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <div className="adm-modal-overlay">
      <div className="adm-modal-content">
        <div className="adm-modal-header">
          <h3>Add Driver</h3>
          <button className="adm-close-x-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="adm-modal-body">
          {/* Row 1 */}
          <div className="adm-form-grid-3">
            <div className="adm-form-group">
              <label>Driver Name *</label>
              <input 
                type="text" 
                name="username" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="Enter name"
              />
            </div>

            <div className="adm-form-group">
              <label>Unique Id *</label>
              <input 
                type="text" 
                name="uniqueId" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="Driver ID"
              />
            </div>

            <div className="adm-form-group">
              <label>Mobile *</label>
              <input 
                type="text" 
                name="mobileNo" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="Phone number"
              />
            </div>
          </div>
<div className="adm-form-group">
  <label>Password *</label>
  <div className="adm-password-wrap">
    <input 
      type={showPassword ? "text" : "password"} 
      name="password" 
      className="adm-form-control adm-form-control-password" 
      onChange={handleChange} 
      placeholder="Set login password"
    />
    <button
      type="button"
      className="adm-password-toggle"
      onClick={() => setShowPassword((prev) => !prev)}
      aria-label={showPassword ? "Hide password" : "Show password"}
    >
      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
    </button>
  </div>
</div>


          {/* Row 2 */}
          <div className="adm-form-grid-3">
            <div className="adm-form-group">
              <label>Address</label>
              <input 
                type="text" 
                name="address" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="Full address"
              />
            </div>

            <div className="adm-form-group">
              <label>License No</label>
              <input 
                type="text" 
                name="licenseNo" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="DL number"
              />
            </div>

            <div className="adm-form-group">
              <label>Validity</label>
              <input 
                type="date" 
                name="licenseValidity" 
                className="adm-form-control" 
                onChange={handleChange} 
              />
            </div>
          </div>

          {/* Row 3 */}
          <div className="adm-form-grid-3">
            <div className="adm-form-group">
              <label>Salary</label>
              <input 
                type="number" 
                name="salary" 
                className="adm-form-control" 
                onChange={handleChange} 
                placeholder="Monthly salary"
              />
            </div>
          </div>
        </div>

        <div className="adm-modal-footer">
          <button className="adm-btn adm-btn-submit" onClick={() => onSubmit(formData)}>
            SUBMIT
          </button>
          <button className="adm-btn adm-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDriverModal;
